var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSaveIcon = function SvgSaveIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 42,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6F5EE",
    fillRule: "evenodd",
    d: "M12.592 7.957a3.765 3.765 0 0 0-3.766 3.765v25.583a3.765 3.765 0 0 0 3.766 3.765h19.235a3.766 3.766 0 0 0 3.765-3.765V12.722l-5.749-4.765H12.592Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ED9C6",
    fillRule: "evenodd",
    d: "M28.85 7.337v2.506a2.26 2.26 0 0 0 2.26 2.26H34.6",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M10.592 5.957a3.765 3.765 0 0 0-3.766 3.765v25.583a3.765 3.765 0 0 0 3.766 3.765h19.235a3.766 3.766 0 0 0 3.765-3.765V10.722l-5.749-4.765H10.592Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E22",
    d: "M27.843 5.957v2.506a2.26 2.26 0 0 0 2.259 2.259h3.49"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4E7B57",
    d: "M21.415 12.295h6.142c.416 0 .753.337.753.753v3.765a.753.753 0 0 1-.753.753H12.863a.753.753 0 0 1-.754-.753v-3.765c0-.416.338-.753.754-.753H17.334"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.201,
    height: 5.272,
    x: 12.109,
    y: 20.518,
    stroke: "#1A1E22",
    rx: 0.753
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16.201,
    height: 5.272,
    x: 12.109,
    y: 28.742,
    stroke: "#1A1E22",
    rx: 0.753
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4E7B57",
    d: "m14.963 14.007 1.39 1.52 3.856-3.796"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBE00",
    d: "m3.972 6.755-2.702.14M6.546 3.577V.925M4.842 4.92l-2.67-2.71"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSaveIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "save-icon.e3d378f7977832e716ebd9e982303bef.svg";